import {Layout} from "@components";
import React from "react";
import styles from "./style.module.scss";
import {useRecoilValue} from "recoil";
import {states} from "@recoils";
import {Images} from "@assets";

export default function HomePage() {
  const infoData = useRecoilValue(states.infoDataState);
  const data = infoData.find(item => item.type === "about");
  const imgUrl = data?.files?.[0]?.url;

  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.titleSection}>회장 인사말</div>
        <div className={styles.contentWrapper}>
          <img src={imgUrl ?? Images.noImage} alt="회장 인사말" />
          <div className={styles.contentSection}>
            <div className={styles.title}>{data?.title}</div>
            <div className={styles.content}>{data?.content}</div>
            <div className={styles.sub_title}>{data?.sub_title}</div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
